module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "activeMenu": "calendar"
    }
  }, [_c('v-panel', [_c('div', {
    staticClass: "page-header-wrapper",
    attrs: {
      "slot": "body",
      "id": "calendar-page"
    },
    slot: "body"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading && _vm.rentals.length > 0) ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "header-tabs"
    }
  }, [_c('div', {
    staticClass: "calendar-filter-area white",
    attrs: {
      "id": "calendar-filter-area"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "id": "clearfix"
    }
  }, [_c('div', {
    staticClass: "booking_tle d-flex align-items-center"
  }, [_c('div', {
    staticClass: "booking-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/SuperHote_icons/notebook.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('calendar.index.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "calender_icon"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('div', {
    staticClass: "col-xl-3 col-lg-1 filter-by-rental"
  }, [_c('button', {
    staticClass: "btn btn-secondary dropdown-toggle",
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "type": "button",
      "id": "dropdownMenuButton",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('booking.index.filter_by_rental')) + "\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "dropdownMenuButton",
      "id": "dropdown-filter-rentals"
    }
  }, [_c('div', [_c('div', {
    staticClass: "form-group form-material",
    attrs: {
      "id": "rental-search"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filteredRentalValue),
      expression: "filteredRentalValue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Rechercher un logement..."
    },
    domProps: {
      "value": (_vm.filteredRentalValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filteredRentalValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.filteredRentalGroups), function(group) {
    return (group.rentals.length > 0) ? _c('ul', {
      staticClass: "checkbox-custom m-l-30 checkbox-primary rental-group rental-group-ul"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedGroups[group.id]),
        expression: "checkedGroups[group.id]"
      }],
      attrs: {
        "type": "checkbox",
        "id": ("calendar-group-" + (group.id))
      },
      domProps: {
        "checked": Array.isArray(_vm.checkedGroups[group.id]) ? _vm._i(_vm.checkedGroups[group.id], null) > -1 : (_vm.checkedGroups[group.id])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.checkedGroups[group.id],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.checkedGroups, group.id, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.checkedGroups, group.id, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.checkedGroups, group.id, $$c)
          }
        }, function($event) {
          _vm.selectGroupForFilter(group.id)
        }]
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "rental-item-name",
      attrs: {
        "for": ("calendar-group-" + (group.id))
      }
    }, [_c('span', [_vm._v(" " + _vm._s(group.name) + " ")])]), _vm._v(" "), _vm._l((group.rentals), function(rental) {
      return _c('li', {
        staticClass: "checkbox-custom m-l-10 checkbox-inline checkbox-primary dropdown-item"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.checkedRentals[rental.id]),
          expression: "checkedRentals[rental.id]"
        }],
        attrs: {
          "type": "checkbox",
          "id": ("calendar-rental-" + (rental.id))
        },
        domProps: {
          "checked": Array.isArray(_vm.checkedRentals[rental.id]) ? _vm._i(_vm.checkedRentals[rental.id], null) > -1 : (_vm.checkedRentals[rental.id])
        },
        on: {
          "change": [function($event) {
            var $$a = _vm.checkedRentals[rental.id],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(_vm.checkedRentals, rental.id, $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(_vm.checkedRentals, rental.id, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(_vm.checkedRentals, rental.id, $$c)
            }
          }, function($event) {
            _vm.selectGroupForFilter(null, rental.id)
          }]
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "rental-item-name",
        attrs: {
          "for": ("calendar-rental-" + (rental.id))
        }
      }, [_c('span', [_vm._v(" " + _vm._s(rental.name) + " ")])])])
    })], 2) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "quick-actions"
  }, [_c('div', [_c('a', {
    staticClass: "clear-selected",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeAllCheckedRentals()
      }
    }
  }, [_vm._v("Effacer")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-red btn-bold waves-effect waves-classic btn-with-caret",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.filterByRentals()
      }
    }
  }, [_vm._v("Sauvegarder")])])])])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-red btn-bold waves-effect waves-classic btn-with-caret",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.actions")) + "\n                        "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    class: ("dropdown-menu calendar-dropdown ul-padding " + (_vm.language !== 'en' ? 'dropdown-fr' : ''))
  }, [(_vm.mode !== 'tasks') ? _c('li', {
    staticClass: "calendar-menu-li",
    on: {
      "click": function($event) {
        _vm.$router.push('/bookings-create')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('calendar.index.add_booking')))])]) : _vm._e(), _vm._v(" "), (_vm.mode !== 'tasks') ? _c('li', {
    staticClass: "calendar-menu-li"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs.exportbookings.exportBookings()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.export_bookings')))])]) : _vm._e(), _vm._v(" "), (_vm.mode !== 'tasks') ? _c('li', {
    staticClass: "calendar-menu-li"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openModal('#import-bookings-from-file')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.import_bookings')))])]) : _vm._e(), _vm._v(" "), (_vm.mode === 'tasks') ? _c('li', {
    staticClass: "calendar-menu-li"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs.tasksCalendar.createTask()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("calendar.tasks.create_task")))])]) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-tabs"
  }, [_c('ul', {
    staticClass: "nav nav-pills calendar-tabs",
    attrs: {
      "id": "calendar-tabs"
    }
  }, [(_vm.accessToDaily || !_vm.user.is_team_member) ? _c('li', {
    class: _vm.mode === 'current' ? 'active' : '',
    attrs: {
      "href": "#current",
      "title": _vm.$t('calendar.tooltips.daily')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeMode('current')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('calendar.tooltips.daily')) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.accessToWeekly || !_vm.user.is_team_member) ? _c('li', {
    class: _vm.mode === 'agenda' ? 'active' : '',
    attrs: {
      "href": "#agenda",
      "title": _vm.$t('calendar.tooltips.weekly')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeMode('agenda')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('calendar.tooltips.weekly')) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.accessToAnnual || !_vm.user.is_team_member) ? _c('li', {
    class: _vm.mode === 'month' ? 'active' : '',
    attrs: {
      "href": "#month",
      "title": _vm.$t('calendar.tooltips.month')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeMode('month')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('calendar.tooltips.month')) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.accessToAnnual || !_vm.user.is_team_member) ? _c('li', {
    class: _vm.mode === 'annual' ? 'active' : '',
    attrs: {
      "href": "#annual",
      "title": _vm.$t('calendar.tooltips.main')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeMode('annual')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('calendar.tooltips.main')) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.accessToTasks || !_vm.user.is_team_member) ? _c('li', {
    class: _vm.mode === 'tasks' ? 'active' : '',
    attrs: {
      "href": "#tasks",
      "title": _vm.$t('calendar.tooltips.tasks')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeMode('tasks')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('calendar.tooltips.tasks')) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.accessToPlanning || !_vm.user.is_team_member) ? _c('li', {
    class: _vm.mode === 'schedule' ? 'active' : '',
    attrs: {
      "href": "#schedule",
      "title": _vm.$t('calendar.tooltips.planning')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeMode('schedule')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('calendar.tooltips.planning')) + "\n              ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "main-content open-main-content01",
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "planning"
  }, [_c('div', {
    staticClass: "calendar-annual-view"
  }, [_c('input', {
    staticClass: "check_in_box",
    attrs: {
      "type": "hidden",
      "id": "check_in",
      "value": "",
      "placeholder": "Check in date"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "check_in_box",
    attrs: {
      "type": "hidden",
      "id": "check_out",
      "value": "",
      "placeholder": "Check out date"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "clicked_element",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "clicked_element_top",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "clicked_element_left",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "is_clicked",
      "value": "0"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "clicked_tr",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "td_width",
      "value": ""
    }
  }), _vm._v(" "), ((_vm.mode === 'annual' || _vm.mode === 'month') && (_vm.accessToAnnual || !_vm.user.is_team_member)) ? _c('div', [_c('div', {
    staticClass: "panel-heading d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "date_change_area"
  }, [_c('div', {
    staticClass: "pre_date",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.prevMonths()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/pre_date_icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "next_date",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.nextMonths()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/next_date_icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.from && _vm.to && _vm.mode === 'annual') ? _c('p', {
    staticClass: "dd_t"
  }, [_vm._v("\n                      " + _vm._s(_vm.getDateForRange(_vm.from)) + " - " + _vm._s(_vm.getDateForRange(_vm.to)) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.mode === 'month') ? _c('p', [_vm._v(_vm._s(_vm.getDateForMonth(_vm.from)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [(_vm.hasAtLeastOneParentWithPlanIdFour()) ? _c('div', {
    staticClass: "col-lg-auto filter-by-restrictions pb-10 pr-0"
  }, [_c('button', {
    staticClass: "btn btn-secondary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('calendar.index.restrictions_filter')) + "\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu filter-restrictions-dropdown",
    attrs: {
      "aria-labelledby": "navbarDropdown"
    }
  }, [_c('ul', {
    staticClass: "checkbox-custom m-l-30 checkbox-primary"
  }, _vm._l((_vm.restrictions), function(restriction, indexName) {
    return _c('li', {
      staticClass: "checkbox-custom m-l-10 checkbox-inline checkbox-primary dropdown-item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (restriction.checked),
        expression: "restriction.checked"
      }],
      attrs: {
        "type": "checkbox",
        "id": indexName
      },
      domProps: {
        "checked": Array.isArray(restriction.checked) ? _vm._i(restriction.checked, null) > -1 : (restriction.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = restriction.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(restriction, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(restriction, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(restriction, "checked", $$c)
          }
        }, function($event) {
          _vm.showOrHideRestrictionRow()
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": indexName
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t(("calendar.index." + (restriction.name)))))])])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center pb-10"
  }, [(!_vm.hasAtLeastOneParentWithPlanIdFour()) ? _c('div', {
    staticClass: "show-min-stay-rows d-flex justify-content-end",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showOrHideRestrictionRow(true, _vm.showPriceSetup)
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.showPriceSetup ?
    _vm.$t('calendar.index.price_setup_hide') :
    _vm.$t('calendar.index.price_setup_show')) + "\n                      ")]) : _vm._e(), _vm._v(" "), (!_vm.user.is_team_member && _vm.user.plan_id !== 4) ? _c('img', {
    staticClass: "sync-room-dates-icon",
    attrs: {
      "src": "static/assets/images/SuperHote_icons/sync.svg",
      "alt": "NO IMAGE"
    },
    on: {
      "click": function($event) {
        _vm.syncRoomDates()
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "planning-header"
  }, [_c('table', {
    attrs: {
      "id": "table_calendar"
    }
  }, _vm._l((_vm.months), function(month, index) {
    return _c('div', {
      staticStyle: {
        "background": "#f3f4f7"
      }
    }, [_c('thead', {
      staticClass: "calendar-table-months"
    }, [_c('tr', [_c('th', {
      staticClass: "rental calendar-rental-title-container"
    }, [(index === 0) ? _c('div', {
      staticClass: "form-material",
      staticStyle: {
        "padding": "5px 11px",
        "margin-bottom": "13px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.rentalsFilteredOnCalendarValue),
        expression: "rentalsFilteredOnCalendarValue"
      }],
      staticClass: "form-control",
      staticStyle: {
        "font-size": "12px"
      },
      attrs: {
        "type": "text",
        "placeholder": "Rechercher un logement..."
      },
      domProps: {
        "value": (_vm.rentalsFilteredOnCalendarValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.rentalsFilteredOnCalendarValue = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.rentalsFilteredOnCalendar.length === 0 && _vm.rentalsFilteredOnCalendarNoRentals) ? _c('small', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Aucun logement trouvé pour ce filtre")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "text-align": "left",
        "padding-left": "15px"
      }
    }, [_vm._v(_vm._s(_vm.checkIfMonthInNextYear(index)) + " " + _vm._s(_vm.years[index]) + "\n                            ")])]), _vm._v(" "), _vm._l((_vm.months_with_days[month]), function(n) {
      return _c('th', {
        staticClass: "d1",
        class: _vm.getClassForDate(n, _vm.month_numbers[index], _vm.years[index]),
        attrs: {
          "id": _vm.getMonthDays(n, _vm.month_numbers[index], index, _vm.years[index])
        }
      }, [_c('abbr', [_vm._v(_vm._s(_vm.getWeekDay(n, _vm.month_numbers[index], "short",
        _vm.years[index])))]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(n < 10 ? '0' + n : n) + "\n                          ")])
    })], 2)]), _vm._v(" "), _c('tbody', {
      staticClass: "planning-content"
    }, [_vm._l((_vm.rentalsFilteredOnCalendar.slice(0, _vm.rentalsFilteredCount)), function(rental, rootIndex) {
      return [(_vm.currentMonthHasBookings(rental.bookings, _vm.month_numbers[index], _vm.years[index], rental.rental_fake_id)) ? _c('tr', {
        class: rental.rental_fake_id ? 'month multiple-rental-row' : 'month rental-28288',
        attrs: {
          "data-cached": "20170504135436",
          "data-rentalid": rental.id,
          "id": 'tr_' + rental.id + '_' + month,
          "data-id": rental.rental_fake_id
        }
      }, [_c('th', {
        staticClass: "rental calendar-rental-title-container",
        attrs: {
          "title": ""
        }
      }, [_c('div', {
        staticClass: "calendar-rental-title"
      }, [_c('span', {
        class: rental.name.length > 25 ? 'calendar-rental-name p-0' : '',
        staticStyle: {
          "text-align": "left",
          "padding-left": "15px"
        }
      }, [_vm._v(_vm._s(rental.name))])])]), _vm._v(" "), _vm._l((_vm.array_dates[index]), function(date, dayIndex) {
        return _c('td', {
          class: _vm.showPriceSetup ? 'start b b1129976 with-client' : 'large-cell start b b1129976 with-client',
          attrs: {
            "data-td-date": _vm.array_correct_dates[index][dayIndex]
          }
        }, [_c('div', {
          class: _vm.getCls(date, rental.bookings, _vm.hasRentalRestrictionsAccess(rental) ? rental.restrictions : rental.room_dates, !_vm.account.is_team_member ? _vm.account.plan_id : rental.user ? rental.user.plan_id : null, rental.booking_rate_id, rental.rental_fake_id) + ' ' + date + '-' + rental.id,
          style: (_vm.getBorderStyle(date, rental.bookings))
        }, [_c('div', {
          staticClass: "a needsclick"
        }), _vm._v(" "), _c('div', {
          attrs: {
            "aaa": _vm.checkCheckingDateVar = _vm.checkCheckingDate(date, rental.bookings)
          }
        }), _vm._v(" "), _c('div', {
          attrs: {
            "aaa": _vm.checkDateVar = _vm.checkDate(date, rental.bookings, _vm.hasRentalRestrictionsAccess(rental) ? rental.restrictions : rental.room_dates,
              _vm.checkCheckingDateVar.existing, rental.booking_rate_id, rental.user && rental.user.plan_id)
          }
        }), _vm._v(" "), _c('div', {
          class: _vm.checkDateVar.class,
          style: (_vm.checkDateVar.style)
        }), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.checkCheckingDateVar.existing),
            expression: "checkCheckingDateVar.existing"
          }],
          class: _vm.checkCheckingDateVar.className,
          style: (_vm.checkCheckingDateVar.styleName)
        }), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.checkCheckingBlockedDateVar = ((!_vm.checkCheckingDateVar.existing && _vm.checkDateVar.class != 'b ') ?
              _vm.checkCheckingBlockedDate(date, _vm.hasRentalRestrictionsAccess(rental) ? rental.restrictions : rental.room_dates, _vm.checkDateVar, rental.booking_rate_id, rental.user && rental.user.plan_id) : false)),
            expression: "checkCheckingBlockedDateVar = ((!checkCheckingDateVar.existing && checkDateVar.class != 'b ') ?\n                                                    checkCheckingBlockedDate(date, hasRentalRestrictionsAccess(rental) ? rental.restrictions : rental.room_dates, checkDateVar, rental.booking_rate_id, rental.user && rental.user.plan_id) : false)"
          }],
          staticClass: "-blocked needsclick"
        }), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: ((_vm.checkDateVar.class != 'b ' && _vm.checkDateVar.class != 'blocked' && !_vm.checkCheckingDateVar.existing && !_vm.checkCheckingBlockedDateVar &&
              _vm.hasPLanAccess(rental) && _vm.hasPriceAccess(rental.id) && !rental.rental_fake_id)),
            expression: "(checkDateVar.class != 'b ' && checkDateVar.class != 'blocked'  && !checkCheckingDateVar.existing && !checkCheckingBlockedDateVar &&\n                                                         hasPLanAccess(rental) && hasPriceAccess(rental.id) && !rental.rental_fake_id)"
          }],
          class: _vm.classForPrice(_vm.checkDateVar, _vm.checkCheckingDateVar.existing),
          attrs: {
            "rel": "popover",
            "data-prices": _vm.checkDateVar.priceAll,
            "data-capacity": rental.capacity,
            "data-dpc": rental.default_persone_count,
            "data-price": _vm.checkDateVar.price
          }
        }, [_vm._v("\n                                  " + _vm._s(_vm.checkDateVar.price ?
          parseInt(_vm.checkDateVar.price) : '') + "\n                                ")])]), _vm._v(" "), _vm._l((_vm.uniqueBookingsList(rental.bookings)), function(booking) {
          return (_vm.isValidDates(date, booking)) ? _c('a', {
            staticClass: "needsclick",
            attrs: {
              "href": "javascript:void(0)"
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                _vm.showDetail(booking, rental)
              }
            }
          }, [_c('span', {
            staticClass: "ninja-btn booking-item",
            style: (_vm.getWidth(date, booking)),
            attrs: {
              "title": ""
            }
          }, [_c('img', {
            attrs: {
              "src": ("static/assets/images/channels-logo/small/" + (booking.channel != null ? (!['Direct','Homeaway', 'Homeaway.com', 'Homeaway iCal'].includes(booking.channel.name) && booking.channel.logo) ? booking.channel.logo : 'rent.png' : 'rent.png')),
              "alt": ""
            }
          }), _vm._v("\n                                  " + _vm._s(booking.guest.first_name ?
            booking.guest.first_name : '') + " " + _vm._s(booking.guest.last_name ?
            booking.guest.last_name : '') + "\n                                ")])]) : _vm._e()
        }), _vm._v(" "), _vm._l((_vm.uniqueBookingsList(rental.bookings)), function(booking) {
          return (_vm.isValidDatesNextMonth(date, booking)) ? _c('a', {
            class: _vm.isCheckoutFirstDayOfMonth(date, booking.checking, booking.checkout) ? 'needsclick needsclick-prev-first-day open-price-modal' : 'needsclick needsclick-prev-month',
            attrs: {
              "href": "javascript:void(0)"
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                _vm.showDetail(booking, rental, $event)
              }
            }
          }, [_c('span', {
            staticClass: "ninja-btn booking-item",
            style: (("margin-top: 11px;" + (_vm.getWidth(date, booking))))
          }), _vm._v(" "), (_vm.isCheckinLastDayOfMonth(date, booking.checking)) ? _c('span', {
            style: (_vm.getWidth(date, booking)),
            attrs: {
              "id": "rental-name-text"
            }
          }, [_vm._v("\n                                  " + _vm._s(booking.guest.first_name ?
            booking.guest.first_name : '') + " " + _vm._s(booking.guest.last_name ?
            booking.guest.last_name : '') + "\n                                ")]) : _vm._e()]) : _vm._e()
        }), _vm._v(" "), (_vm.isValidBlockedDates(date, _vm.hasRentalRestrictionsAccess(rental) ? rental.restrictions : rental.room_dates)) ? _c('a', {
          staticClass: "needsclick",
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.showPriceModal(rental, _vm.array_correct_dates[index][dayIndex])
            }
          }
        }, [_c('span', {
          staticClass: "ninja-btn",
          attrs: {
            "title": ""
          }
        })]) : _vm._e()], 2)
      })], 2) : _vm._e(), _vm._v(" "), (_vm.showPriceSetup && ((_vm.restrictions.minStay.checked && !rental.rental_fake_id) || (_vm.account.plan_id !== 4 && !_vm.account.is_team_member))) ? _c('tr', {
        staticClass: "rental-config-row month",
        attrs: {
          "data-rentalid": rental.id,
          "id": ("tr_" + (rental.id) + "_" + month)
        }
      }, [_c('th', {
        staticClass: "rental"
      }, [_c('span', {
        staticClass: "rental-config-title"
      }, [_vm._v("\n                                " + _vm._s(_vm.$t("calendar.index.min_stay.title")) + "\n                              ")])]), _vm._v(" "), _vm._l((_vm.array_dates[index]), function(date, dayIndex) {
        return _c('td', {
          class: _vm.showPriceSetup ? '' : 'large-cell',
          attrs: {
            "data-td-date": _vm.array_correct_dates[index][dayIndex]
          }
        }, [_c('div', {
          staticClass: "g"
        }, [_c('div', {
          staticClass: "needsclick min-stay-cell rental-config-cell"
        }), _vm._v(" "), _c('div', {
          staticClass: "min-stay-number d-flex justify-content-center align-items-center"
        }, [_vm._v("\n                                  " + _vm._s(_vm.checkDate(date, [],
          _vm.hasRentalRestrictionsAccess(rental) ?
          rental.restrictions : rental.room_dates,
          _vm.checkCheckingDateVar.existing,
          rental.booking_rate_id,
          (_vm.account.is_team_member && rental.user &&
            rental.user.plan_id === 4) &&
          rental.user.plan_id).minStay) + "\n                                ")])])])
      })], 2) : _vm._e(), _vm._v(" "), (_vm.hasAccessToRestrictions(rental, 'override')) ? _c('tr', {
        staticClass: "rental-config-row month",
        attrs: {
          "data-rentalid": rental.id,
          "id": ("tr_" + (rental.id) + "_" + month)
        }
      }, [_c('th', {
        staticClass: "rental"
      }, [_c('span', {
        staticClass: "rental-config-title"
      }, [_vm._v("\n                                " + _vm._s(_vm.$t("calendar.index.override.title")))])]), _vm._v(" "), _vm._l((_vm.array_dates[index]), function(date, dayIndex) {
        return _c('td', {
          attrs: {
            "data-td-date": _vm.array_correct_dates[index][dayIndex]
          }
        }, [_c('div', {
          staticClass: "g"
        }, [_c('div', {
          staticClass: "needsclick override-cell rental-config-cell"
        }), _vm._v(" "), (_vm.checkDate(date, [], rental.restrictions, _vm.checkCheckingDateVar.existing, rental.booking_rate_id, rental.user && rental.user.plan_id).overrideStatus > 0) ? _c('div', {
          staticClass: "d-flex justify-content-center align-items-center"
        }, [_c('p', {
          staticClass: "override-status",
          attrs: {
            "data-override-status": _vm.checkDate(date, [], rental.restrictions, _vm.checkCheckingDateVar.existing, rental.booking_rate_id).overrideStatus
          }
        }, [_vm._v("\n                                    " + _vm._s(_vm.getOverrideStatusName(parseInt(_vm.checkDate(date, [],
          rental.restrictions,
          _vm.checkCheckingDateVar.existing,
          rental.booking_rate_id, rental.user &&
          rental.user.plan_id).overrideStatus))) + "\n                                  ")])]) : _vm._e()])])
      })], 2) : _vm._e(), _vm._v(" "), (_vm.hasAccessToRestrictions(rental, 'inventory')) ? _c('tr', {
        staticClass: "rental-config-row month",
        attrs: {
          "data-rentalid": rental.id,
          "id": ("tr_" + (rental.id) + "_" + month)
        }
      }, [_c('th', {
        staticClass: "rental"
      }, [_c('span', {
        staticClass: "rental-config-title"
      }, [_vm._v(" " + _vm._s(_vm.$t("calendar.index.inventory_title")))])]), _vm._v(" "), _vm._l((_vm.array_dates[index]), function(date, dayIndex) {
        return _c('td', {
          attrs: {
            "data-td-date": _vm.array_correct_dates[index][dayIndex]
          }
        }, [_c('div', {
          staticClass: "g"
        }, [_c('div', {
          staticClass: "needsclick inventory-cell rental-config-cell"
        }), _vm._v(" "), _c('div', {
          staticClass: "inventory-number d-flex justify-content-center align-items-center"
        }, [_vm._v("\n                                  " + _vm._s(_vm.checkDate(date, [], rental.restrictions, _vm.checkCheckingDateVar.existing, null,
          rental.user && rental.user.plan_id).inventoryNumber) + "\n                                ")])])])
      })], 2) : _vm._e(), _vm._v(" "), (rootIndex === _vm.rentalsFilteredCount - 1 && _vm.rentalsFilteredOnCalendar.length > 10 && _vm.rentalsFilteredCount < _vm.rentalsFilteredOnCalendar.length) ? _c('tr', {
        staticStyle: {
          "border": "0",
          "background": "#f1f2f5"
        }
      }, [_c('th', {
        staticStyle: {
          "background": "#f3f4f7",
          "padding-top": "0",
          "border": "0"
        }
      }, [_c('div', {
        staticStyle: {
          "background": "#fff",
          "height": "13px"
        }
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "justify-content": "center",
          "border-top": "1px solid #999999",
          "margin-left": "-10px"
        }
      }, [_c('button', {
        staticClass: "btn btn-bold waves-effect waves-classic btn-with-caret",
        staticStyle: {
          "background": "#999",
          "color": "#fff",
          "font-size": "12px",
          "padding": "5px 17px !important",
          "border-radius": "0px 0px 5px 5px"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.loadMoreRentals($event)
          }
        }
      }, [_vm._v("Afficher plus")])])]), _vm._v(" "), _vm._l((_vm.array_dates[index]), function(date, dayIndex) {
        return _c('td', {
          class: _vm.showPriceSetup ? '' : 'large-cell',
          staticStyle: {
            "background": "#f0f1f4 !important",
            "padding": "0",
            "margin": "0",
            "display": "table-cell"
          }
        }, [_c('div', {
          staticStyle: {
            "background": "#fff",
            "height": "17px",
            "border-bottom": "1px solid #999999",
            "margin-top": "-27px"
          }
        })])
      })], 2) : _vm._e()]
    })], 2)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "date_change_area clearfix"
  }, [_c('div', {
    staticClass: "pre_date",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.prevMonths()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/pre_date_icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "next_date",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.nextMonths()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/next_date_icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.from && _vm.to && _vm.mode === 'annual') ? _c('p', {
    staticClass: "dd_t"
  }, [_vm._v("\n                      " + _vm._s(_vm.getDateForRange(_vm.from)) + " - " + _vm._s(_vm.getDateForRange(_vm.to)) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.mode === 'month') ? _c('p', [_vm._v(_vm._s(_vm.getDateForMonth(_vm.from)))]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), (_vm.mode === 'agenda' && (_vm.accessToWeekly || !_vm.user.is_team_member)) ? _c('div', {
    staticClass: "agenda-mod-view"
  }, [_c('div', {
    staticClass: "planning"
  }, [_c('div', [_c('div', {
    staticClass: "widget-11 no-border no-margin widget-loader-bar agenda_view_sec"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "date_change_area clearfix"
  }, [_c('div', {
    staticClass: "pre_date",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.prevWeek(_vm.week_days[0])
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/pre_date_icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "next_date",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.nextWeek(_vm.week_days[6])
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/next_date_icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "dd_t"
  }, [_vm._v("\n                          " + _vm._s(_vm.getDateForRange(_vm.week_days[0])) + " - " + _vm._s(_vm.getDateForRange(_vm.week_days[6])) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "agenda_view"
  }, _vm._l((_vm.week_days), function(week_day, index) {
    return _c('table', {
      staticClass: "table table-condensed table-hover"
    }, [_c('thead', [_c('tr', [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("\n                              " + _vm._s(_vm.getDateForTitle(week_day)) + " ( " + _vm._s(_vm.getCurrentDateCheckinsOrCheckoutsCount(_vm.agentaBookings,
      week_day)) + " " + _vm._s(_vm.$t('calendar.booking-detail.checkin')) + " - " + _vm._s(_vm.getCurrentDateCheckinsOrCheckoutsCount(_vm.agentaBookings,
      week_day, 'checkout')) + " " + _vm._s(_vm.$t('calendar.booking-detail.checkout')) + " )\n                            ")]), _vm._v(" "), _c('th', {
      staticClass: "yr"
    }, [_vm._v(_vm._s(_vm.getYear(week_day)))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.agentaBookings), function(agentaBooking) {
      return _c('tr', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (week_day == agentaBooking.checking || week_day == agentaBooking.checkout),
          expression: "week_day == agentaBooking.checking || week_day == agentaBooking.checkout"
        }],
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.showDetail(agentaBooking, agentaBooking.rental)
          }
        }
      }, [_c('td', [_c('span', {
        staticClass: "font-montserrat all-caps fs-18"
      }, [_vm._v("\n                                " + _vm._s(agentaBooking.guest.first_name ?
        agentaBooking.guest.first_name : '') + " " + _vm._s(agentaBooking.guest.last_name ?
        agentaBooking.guest.last_name : ''))]), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(agentaBooking.nbr_adults) + " ad - " + _vm._s(agentaBooking.nbr_children) + " enf, " + _vm._s(_vm._f("calculateNight")(agentaBooking.checking, agentaBooking.checkout)) + " " + _vm._s(_vm.$t('nights')) + "\n                              ")])]), _vm._v(" "), _c('td', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (week_day == agentaBooking.checking),
          expression: "week_day == agentaBooking.checking"
        }]
      }, [_c('span', {
        staticClass: "arrival"
      }, [_c('img', {
        attrs: {
          "src": "static/assets/images/arrival_icon.png",
          "alt": ""
        }
      })]), _vm._v(" "), _c('h5', {
        staticClass: "check_type"
      }, [_vm._v("\n                                " + _vm._s(agentaBooking.rental.name) + "\n                              ")]), _vm._v(" "), _c('p', {
        staticClass: "time"
      }, [_vm._v("\n                                " + _vm._s(_vm.getDateForBooking(agentaBooking.checking)) + "\n                                " + _vm._s(agentaBooking.time_in && ' - ' +
        _vm.timeFormat(agentaBooking.time_in)) + "\n                              ")])]), _vm._v(" "), _c('td', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (week_day != agentaBooking.checking),
          expression: "week_day != agentaBooking.checking "
        }]
      }, [_c('span', {
        staticClass: "arrival"
      }, [_c('img', {
        attrs: {
          "src": "static/assets/images/deperture_icon.png",
          "alt": "NO IMAGE"
        }
      })]), _vm._v(" "), _c('h5', {
        staticClass: "check_type"
      }, [_vm._v("\n                                " + _vm._s(agentaBooking.rental.name) + "\n                              ")]), _vm._v(" "), _c('p', {
        staticClass: "time"
      }, [_vm._v("\n                                " + _vm._s(_vm.getDateForBooking(agentaBooking.checkout)) + "\n                                " + _vm._s(agentaBooking.time_out && ' - ' +
        _vm.timeFormat(agentaBooking.time_out)) + "\n                              ")])]), _vm._v(" "), _c('td', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (week_day == agentaBooking.checkout),
          expression: "week_day == agentaBooking.checkout"
        }]
      }, [_c('span', {
        staticClass: "arrival"
      }, [_c('img', {
        attrs: {
          "src": "static/assets/images/arrival_icon.png",
          "alt": "NO IMAGE"
        }
      })]), _vm._v(" "), _c('h5', {
        staticClass: "check_type"
      }, [_vm._v("\n                                " + _vm._s(agentaBooking.rental.name) + "\n                              ")]), _vm._v(" "), _c('p', {
        staticClass: "time"
      }, [_vm._v("\n                                " + _vm._s(_vm.getDateForBooking(agentaBooking.checking)) + "\n                                " + _vm._s(agentaBooking.time_in && ' - ' +
        _vm.timeFormat(agentaBooking.time_in)) + "\n                              ")])]), _vm._v(" "), _c('td', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (week_day != agentaBooking.checkout),
          expression: "week_day != agentaBooking.checkout"
        }]
      }, [_c('span', {
        staticClass: "arrival"
      }, [_c('img', {
        attrs: {
          "src": "static/assets/images/deperture_icon.png",
          "alt": "NO IMAGE"
        }
      })]), _vm._v(" "), _c('h5', {
        staticClass: "check_type"
      }, [_vm._v("\n                                " + _vm._s(agentaBooking.rental.name) + "\n                              ")]), _vm._v(" "), _c('p', {
        staticClass: "time"
      }, [_vm._v("\n                                " + _vm._s(_vm.getDateForBooking(agentaBooking.checkout)) + "\n                                " + _vm._s(agentaBooking.time_out && ' - ' +
        _vm.timeFormat(agentaBooking.time_out)) + "\n                              ")])])])
    }))])
  }))])])])]) : _vm._e()]), _vm._v(" "), _c('section', [(_vm.mode === 'current' && (_vm.accessToDaily || !_vm.user.is_team_member)) ? _c('div', [_c('v-current', {
    ref: "dailyCalendar",
    attrs: {
      "checkedRentals": _vm.checkedRentals
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.mode == 'schedule' && (_vm.accessToPlanning || !_vm.user.is_team_member)) ? _c('section', [_c('v-scheduler', {
    ref: "scheduleCalendar",
    attrs: {
      "checkedRentals": _vm.checkedRentals
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mode == 'tasks' && (_vm.accessToTasks || !_vm.user.is_team_member)) ? _c('section', [_c('v-tasks', {
    ref: "tasksCalendar",
    attrs: {
      "checkedRentals": _vm.checkedRentals
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bookingDetails),
      expression: "bookingDetails"
    }],
    staticClass: "calendar-month-view"
  }, [_c('div', {
    staticClass: "panel panel-white left"
  }, [_c('div', {
    staticClass: "pannel_sec"
  }, [_c('div', {
    staticClass: "cross_icon",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeDetailModal()
      }
    }
  }, [_vm._v("\n                x\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "pannel_details"
  }, [_c('h2', {
    staticClass: "tle_p"
  }, [_c('div', {
    staticClass: "event-fullname"
  }, [_vm._v("\n                    " + _vm._s(_vm.guest.first_name ? _vm.guest.first_name : '') + " " + _vm._s(_vm.guest.last_name ? _vm.guest.last_name : '') + "\n                  ")]), _vm._v(" "), _c('span', [_vm._v("("), _c('span', {
    staticClass: "event-bookingid"
  }, [_vm._v(_vm._s(_vm.booking.id))]), _vm._v(")\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "c_date c_date_a"
  }, [_c('p', {
    staticClass: "margin-bottom-10"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("calendar.booking-detail.rental_name")) + " :\n                    "), _c('span', [_vm._v(_vm._s(_vm.booking && _vm.booking.rental ? _vm.booking.rental.name :
    _vm.rental.name))])]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("calendar.booking-detail.booking_date")) + " :\n                    "), (_vm.booking.booking_date) ? _c('span', {
    staticClass: "event-checkin"
  }, [_vm._v(_vm._s(_vm.getWeekDayFromDateCalendar(_vm.booking.booking_date)))]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("calendar.booking-detail.checkin")) + " :\n                    "), (_vm.booking.checking) ? _c('span', {
    staticClass: "event-checkin"
  }, [_vm._v(_vm._s(_vm.getWeekDayFromDateCalendar(_vm.booking.checking)))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "margin-bottom-10"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("calendar.booking-detail.checkout")) + " :\n                    "), (_vm.booking.checkout) ? _c('span', {
    staticClass: "event-checkout"
  }, [_vm._v(_vm._s(_vm.getWeekDayFromDateCalendar(_vm.booking.checkout)))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "event_referer"
  }), _vm._v(" "), _c('p', {
    staticClass: "mb-10"
  }, [_c('span', {
    staticClass: "event-adults"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("calendar.booking-detail.nb_adults")) + " : " + _vm._s(_vm.booking.nbr_adults) + " -\n                      "), _c('span', {
    staticClass: "event-children"
  }, [_vm._v(_vm._s(_vm.$t("calendar.booking-detail.nb_children")) + " :\n                        " + _vm._s(_vm.booking.nbr_children))])])]), _vm._v(" "), (_vm.booking.booking_com_res_id) ? _c('p', {
    staticClass: "margin-bottom-10"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("calendar.booking-detail.reservation_status")) + " :\n                    "), _c('span', [_vm._v(_vm._s(_vm.getReservationStatusName(_vm.booking.reservation_status)))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "event_referer"
  }), _vm._v(" "), ((_vm.user.is_team_member && _vm.user.rights && _vm.showBookingPrices) || !_vm.user.is_team_member) ? _c('div', {
    staticClass: "margin-bottom-15 price"
  }, [_vm._v("\n                    " + _vm._s(_vm.getBookingChannelName(_vm.channel, _vm.booking.original_referrer,
    _vm.booking.ical)) + "\n                    "), _c('span', [_vm._v("(\n                      "), _c('span', [_vm._v(_vm._s(_vm.getPriceAmount(_vm.booking)))]), _vm._v("\n                      " + _vm._s(_vm.rental && _vm.rental.currency ? _vm.rental.currency.symbol :
    _vm.user.currency.symbol) + " )\n                    ")]), _vm._v(" "), (_vm.bookingUrl) ? _c('span', [_c('a', {
    attrs: {
      "href": _vm.bookingUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.booking_page')))])]) : _vm._e(), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.user.is_team_member || (_vm.user.is_team_member && _vm.user.rights && _vm.showBookingActions)) ? _c('p', {
    class: _vm.isExtraDataLong(_vm.booking.extra_data_from_form) ? 'overflow-panel-notes panel-notes' : 'panel-notes'
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('input.notes')) + " :\n                    "), _c('span', [_vm._v(_vm._s(_vm.getBookingExtraDetails(_vm.booking.extra_data_from_form)))])]) : _vm._e(), _vm._v(" "), (!_vm.user.is_team_member || (_vm.user.is_team_member && _vm.user.rights && _vm.showBookingActions)) ? _c('p', {
    class: _vm.isExtraDataLong(_vm.booking.extra_data_from_form, 'comments') ? 'overflow-panel-notes panel-notes margin-bottom-10' : 'panel-notes margin-bottom-10'
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('booking.detail.events.comments')) + " :\n                    "), _c('span', [_vm._v(_vm._s(_vm.getBookingExtraDetails(_vm.booking.extra_data_from_form,
    'comments')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form_group_attached"
  }, [_c('div', {
    staticClass: "form_group_half"
  }, [_c('div', {
    staticClass: "form_group form_group_half_col"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t("calendar.booking-detail.arrival")) + "\n                      ")]), _vm._v(" "), _c('span', {
    staticClass: "box event-arrival"
  }, [_vm._v(_vm._s(_vm.booking.time_in ? _vm.booking.time_in : "N/A"))])]), _vm._v(" "), _c('div', {
    staticClass: "form_group form_group_half_col"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t("calendar.booking-detail.departure")) + "\n                      ")]), _vm._v(" "), _c('span', {
    staticClass: "box event-arrival"
  }, [_vm._v(_vm._s(_vm.booking.time_out ? _vm.booking.time_out : "N/A"))])])]), _vm._v(" "), _c('div', {
    staticClass: "form_group"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t("calendar.booking-detail.email")) + "\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "box event-email"
  }, [_vm._v(_vm._s(_vm.guest.email ? _vm.guest.email : "N/A"))])]), _vm._v(" "), _c('div', {
    staticClass: "form_group"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t("calendar.booking-detail.mobile")) + "\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "box event-phone"
  }, [_vm._v(_vm._s(_vm.guest ? _vm.guest.phone : "N/A"))])]), _vm._v(" "), _c('div', {
    staticClass: "form_group_half form-control-margin-0"
  }, [_c('div', {
    staticClass: "form_group form-group-default form_group_half_col"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t("calendar.booking-detail.payment")) + "\n                      ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentStatus),
      expression: "paymentStatus"
    }],
    staticClass: "form-control change-booking-status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.paymentStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changeStatus('payment', _vm.booking)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "OK"
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "KO"
    }
  }, [_vm._v("KO")])])]), _vm._v(" "), _c('div', {
    staticClass: "form_group form-group-default form_group_half_col"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t("calendar.booking-detail.deposit")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.depositStatus),
      expression: "depositStatus"
    }],
    staticClass: "form-control change-booking-status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.depositStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changeStatus('deposit', _vm.booking)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "OK"
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "KO"
    }
  }, [_vm._v("KO")])])]), _vm._v(" "), _c('div', {
    staticClass: "form_group form_group_half_col form-group-default"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t("calendar.booking-detail.welcome_form_submitted")) + "\n                      ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.welcome_form_submitted),
      expression: "booking.welcome_form_submitted"
    }],
    staticClass: "form-control change-booking-status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.booking, "welcome_form_submitted", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.changeFormStatus('welcome', _vm.booking)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("KO")])])]), _vm._v(" "), _c('div', {
    staticClass: "form_group form_group_half_col form-group-default"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t("calendar.booking-detail.checkin_form_submitted")) + "\n                      ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.checkin_form_submitted),
      expression: "booking.checkin_form_submitted"
    }],
    staticClass: "form-control change-booking-status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.booking, "checkin_form_submitted", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.changeFormStatus('checkin', _vm.booking)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("KO")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form_group_half_col form-group-default"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('label', {
    staticClass: "booking-status"
  }, [_vm._v(_vm._s(_vm.$t("calendar.booking-detail.to_throw_back")))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "title": _vm.$t('calendar.booking-detail.follow_up_info')
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.follow_up),
      expression: "booking.follow_up"
    }],
    staticClass: "form-control change-booking-status",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.booking, "follow_up", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.onChangeFollowUp()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.yes')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.no')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form_group_half_col form-group-default"
  }, [_c('div', {
    staticClass: "d-flex contract-status"
  }, [_c('label', {
    staticClass: "booking-status"
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.contract.title')) + "\n                        ")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "box"
  }, [_vm._v(_vm._s(_vm.booking.is_booking_contract_signed ?
    _vm.$t('booking.detail.signed') :
    _vm.$t('booking.detail.not_signed')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form_group_half form-control-margin-0"
  }, [_c('div', {
    staticClass: "form_group form-group-default form_group_half_col border-top-0"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t('account.users.teamMember.assignCheckin')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.assigned_to_checking),
      expression: "booking.assigned_to_checking"
    }],
    staticClass: "form-control change-booking-status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.booking, "assigned_to_checking", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.addOrChangeTeamMember(_vm.booking.id, _vm.booking.assigned_to_checking, 'checking')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("-")]), _vm._v(" "), _vm._l((_vm.membersForChecking), function(member) {
    return _c('option', {
      domProps: {
        "value": member.id
      }
    }, [_vm._v("\n                          " + _vm._s(((member.first_name) + " " + (member.last_name))) + "\n                        ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form_group form-group-default form_group_half_col border-top-0"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t('account.users.teamMember.assignCheckout')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.assigned_to_checkout),
      expression: "booking.assigned_to_checkout"
    }],
    staticClass: "form-control change-booking-status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.booking, "assigned_to_checkout", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.addOrChangeTeamMember(_vm.booking.id, _vm.booking.assigned_to_checkout, 'checkout')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("-")]), _vm._v(" "), _vm._l((_vm.membersForCheckout), function(member) {
    return _c('option', {
      domProps: {
        "value": member.id
      }
    }, [_vm._v("\n                          " + _vm._s(((member.first_name) + " " + (member.last_name))) + "\n                        ")])
  })], 2)])])]), _vm._v(" "), (!_vm.user.is_team_member || (_vm.user.is_team_member == 1 && _vm.user.rights && _vm.showBookingActions)) ? _c('div', {
    staticClass: "other-actions"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.booking.areLocksConnectedToBookingRental && !_vm.user.is_team_member),
      expression: "booking.areLocksConnectedToBookingRental && !user.is_team_member"
    }],
    staticClass: "form-group form-group-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openModal('#controlLocks-modal')
      }
    }
  }, [_c('label', {
    staticClass: "pull-left cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t('rentals.detail.locks_management')))]), _vm._v(" "), _c('div', {
    staticClass: "p-t-10"
  }, [_c('a', {
    staticClass: "custom-action-link",
    staticStyle: {
      "width": "100%",
      "color": "inherit"
    }
  }, [_c('span', {
    staticClass: "pull-right p-r-10 p-b-5"
  }, [_c('i', {
    staticClass: "icon md-chevron-right"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toBooking(_vm.booking.id, 'invoices')
      }
    }
  }, [_c('label', {
    staticClass: "pull-left cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t("button.view_invoice")))]), _vm._v(" "), _c('div', {
    staticClass: "p-t-10"
  }, [_c('a', {
    staticClass: "custom-action-link",
    staticStyle: {
      "width": "100%",
      "color": "inherit"
    },
    attrs: {
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "pull-right p-r-10 p-b-5"
  }, [_c('i', {
    staticClass: "icon md-chevron-right"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toBooking(_vm.booking.id, 'payments')
      }
    }
  }, [_c('label', {
    staticClass: "pull-left cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t("button.view_payment")))]), _vm._v(" "), _c('div', {
    staticClass: "p-t-10"
  }, [_c('a', {
    staticClass: "custom-action-link",
    staticStyle: {
      "width": "100%",
      "color": "inherit"
    },
    attrs: {
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "pull-right p-r-10 p-b-5"
  }, [_c('i', {
    staticClass: "icon md-chevron-right"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toBooking(_vm.booking.id, 'contract')
      }
    }
  }, [_c('label', {
    staticClass: "pull-left cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.contract.title")))]), _vm._v(" "), _c('div', {
    staticClass: "p-t-10"
  }, [_c('a', {
    staticClass: "custom-action-link",
    staticStyle: {
      "width": "100%",
      "color": "inherit"
    },
    attrs: {
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "pull-right p-r-10 p-b-5"
  }, [_c('i', {
    staticClass: "icon md-chevron-right"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toBooking(_vm.booking.id, 'messages')
      }
    }
  }, [_c('label', {
    staticClass: "pull-left cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t("button.view_messages")))]), _vm._v(" "), _c('div', {
    staticClass: "p-t-10"
  }, [_c('a', {
    staticClass: "custom-action-link",
    staticStyle: {
      "width": "100%",
      "color": "inherit"
    },
    attrs: {
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "pull-right p-r-10 p-b-5"
  }, [_c('i', {
    staticClass: "icon md-chevron-right"
  })])])])])]) : _vm._e(), _vm._v(" "), ((_vm.user.is_team_member && _vm.user.rights && _vm.showBookingPrices && _vm.showBookingActions) || !_vm.user.is_team_member) ? _c('div', {
    staticClass: "btnn"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic button-booking-detail p-0",
    attrs: {
      "id": "eventSave"
    },
    on: {
      "click": function($event) {
        _vm.toBooking(_vm.booking.id, 'informations', true)
      }
    }
  }, [_c('a', {
    staticClass: "button-booking-detail",
    attrs: {
      "href": ("#/bookings/" + (_vm.booking.id) + "/informations")
    }
  }, [_vm._v(_vm._s(_vm.$t('button.booking_details')))])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editPriceView),
      expression: "editPriceView"
    }],
    staticClass: "edit-price-view"
  }, [_c('div', {
    staticClass: "panel panel-white panel-price left"
  }, [_c('div', {
    staticClass: "pannel_sec"
  }, [_c('div', {
    staticClass: "cross_icon",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeEditPriceModal()
      }
    }
  }, [_vm._v("\n                x\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "pannel_details"
  }, [_c('div', {
    staticClass: "rental-name-section"
  }, [_c('h2', {
    staticClass: "tle_p"
  }, [_c('div', {
    staticClass: "rental-name"
  }, [_vm._v(_vm._s(_vm.editPrice.rental.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "radio-cont d-flex pt-25"
  }, [_c('div', {
    staticClass: "radio-custom radio-primary m-l-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showRestrictionType),
      expression: "showRestrictionType"
    }],
    attrs: {
      "type": "radio",
      "id": "price-restriction",
      "value": "price"
    },
    domProps: {
      "checked": _vm._q(_vm.showRestrictionType, "price")
    },
    on: {
      "change": function($event) {
        _vm.showRestrictionType = "price"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "price-restriction"
    }
  }, [_vm._v(_vm._s(_vm.$t('input.price')))])]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-primary m-l-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showRestrictionType),
      expression: "showRestrictionType"
    }],
    attrs: {
      "type": "radio",
      "id": "availabilityRestriction",
      "value": "availability"
    },
    domProps: {
      "checked": _vm._q(_vm.showRestrictionType, "availability")
    },
    on: {
      "change": function($event) {
        _vm.showRestrictionType = "availability"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "availabilityRestriction"
    }
  }, [_vm._v(_vm._s(_vm.$t('calendar.index.availability')))])])]), _vm._v(" "), _c('div', {
    staticClass: "edit-price-section"
  }, [(_vm.account.plan_id !== 1) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRestrictionType === 'price'),
      expression: "showRestrictionType === 'price'"
    }],
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "price-number"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('calendar.index.price')) + "\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPrice.price),
      expression: "editPrice.price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "price-number"
    },
    domProps: {
      "value": (_vm.editPrice.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editPrice, "price", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.priceError) ? _c('small', {
    staticStyle: {
      "color": "red",
      "font-size": "12px",
      "font-style": "italic"
    }
  }, [_vm._v(_vm._s(_vm.priceError))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRestrictionType === 'availability'),
      expression: "showRestrictionType === 'availability'"
    }],
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n                      " + _vm._s(_vm.hasPlanIdFourAccess(_vm.editPrice.rental) ?
    _vm.$t('input.status') : _vm.$t('calendar.index.availability')) + "\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPrice.availability),
      expression: "editPrice.availability"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "edit-availability"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editPrice, "availability", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('calendar.index.available')) + "\n                      ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('calendar.index.disabled')) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('input.start_date')) + "\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('datepicker', {
    staticClass: "form-control",
    attrs: {
      "id": "edit-price-start-date",
      "disabled-dates": _vm.startDate.disabled,
      "language": _vm.language === 'fr' ? _vm.fr : _vm.en,
      "format": "D dd MMMM yyyy"
    },
    model: {
      value: (_vm.editPrice.startDate),
      callback: function($$v) {
        _vm.$set(_vm.editPrice, "startDate", $$v)
      },
      expression: "editPrice.startDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('input.end_date')) + "\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('datepicker', {
    staticClass: "form-control",
    attrs: {
      "id": "edit-price-end-date",
      "disabled-dates": _vm.endDate.disabled,
      "language": _vm.language === 'fr' ? _vm.fr : _vm.en,
      "format": "D dd MMMM yyyy"
    },
    model: {
      value: (_vm.editPrice.endDate),
      callback: function($$v) {
        _vm.$set(_vm.editPrice, "endDate", $$v)
      },
      expression: "editPrice.endDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row week-days"
  }, [_c('ul', {
    staticClass: "week-day-name d-flex align-items-center"
  }, _vm._l((_vm.editPrice.week_days), function(day, index) {
    return _c('li', {
      staticClass: "checkbox-custom checkbox-inline checkbox-primary dropdown-item d-flex align-items-center",
      on: {
        "click": function($event) {
          _vm.selectWeekDays(index)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editPrice.week_days[index].selected),
        expression: "editPrice.week_days[index].selected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.editPrice.week_days[index].selected) ? _vm._i(_vm.editPrice.week_days[index].selected, null) > -1 : (_vm.editPrice.week_days[index].selected)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.editPrice.week_days[index].selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.editPrice.week_days[index], "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.editPrice.week_days[index], "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.editPrice.week_days[index], "selected", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "d-flex align-items-center"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t(("calendar.index.week_days." + (day.name)))))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading || _vm.rentalRateLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-red btn-bold waves-effect waves-classic btn-with-caret",
    attrs: {
      "type": "button",
      "disabled": _vm.smallLoading || _vm.rentalRateLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openMultiSelectModal(_vm.editPrice, true, 'price')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("button.save")) + "\n                    ")])], 1), _vm._v(" "), (_vm.hasPermissionForMultiSelect) ? _c('div', {
    staticClass: "checkbox-custom checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableMultipleModification),
      expression: "enableMultipleModification"
    }],
    attrs: {
      "type": "checkbox",
      "id": "price-multiple-modification",
      "disabled": _vm.disabledCheckbox
    },
    domProps: {
      "checked": Array.isArray(_vm.enableMultipleModification) ? _vm._i(_vm.enableMultipleModification, null) > -1 : (_vm.enableMultipleModification)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.enableMultipleModification,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.enableMultipleModification = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.enableMultipleModification = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.enableMultipleModification = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "price-multiple-modification"
    }
  }, [_vm._v(_vm._s(_vm.$t('multiple_modifications')))])]) : _vm._e()])])])])]), _vm._v(" "), _c('VEditMinStay', {
    attrs: {
      "editRentalMinStay": _vm.editRentalMinStay,
      "rentalMinStayData": _vm.rentalMinStayData,
      "from": _vm.from,
      "to": _vm.to,
      "selectedWeekDays": _vm.selectedWeekDays,
      "weekDays": _vm.weekDays,
      "minStayRentalsIds": _vm.minStayRentalsIds,
      "enableOpenModal": _vm.enableOpenModal,
      "hasPermissionForMultiSelect": _vm.hasPermissionForMultiSelect
    },
    on: {
      "closeEditRentalMinStayModal": _vm.closeEditRentalMinStayModal,
      "getRentals": _vm.get_rentals,
      "selectRestrictionWeekDays": _vm.selectRestrictionWeekDays,
      "openMultiSelectModal": _vm.openMultiSelectModal,
      "updateMultiSelectModal": _vm.updateMultiSelectModal
    }
  }), _vm._v(" "), _c('VOverride', {
    attrs: {
      "overridePanelOpened": _vm.overridePanelOpened,
      "overrideData": _vm.overrideData,
      "from": _vm.from,
      "to": _vm.to,
      "selectedWeekDays": _vm.selectedWeekDays,
      "weekDays": _vm.weekDays,
      "overrideRentalsIds": _vm.overrideRentalsIds,
      "enableOpenModal": _vm.enableOpenModal,
      "hasPermissionForMultiSelect": _vm.hasPermissionForMultiSelect
    },
    on: {
      "closeOverridePanel": _vm.closeOverridePanel,
      "getRentals": _vm.get_rentals,
      "selectRestrictionWeekDays": _vm.selectRestrictionWeekDays,
      "openMultiSelectModal": _vm.openMultiSelectModal,
      "updateMultiSelectModal": _vm.updateMultiSelectModal
    }
  }), _vm._v(" "), _c('VInventory', {
    attrs: {
      "inventoryPanelOpened": _vm.inventoryPanelOpened,
      "inventoryData": _vm.inventoryData,
      "from": _vm.from,
      "to": _vm.to,
      "selectedWeekDays": _vm.selectedWeekDays,
      "weekDays": _vm.weekDays,
      "inventoryRentalsIds": _vm.inventoryRentalsIds,
      "enableOpenModal": _vm.enableOpenModal,
      "hasPermissionForMultiSelect": _vm.hasPermissionForMultiSelect
    },
    on: {
      "closeInventoryPanel": _vm.closeInventoryPanel,
      "getRentals": _vm.get_rentals,
      "selectRestrictionWeekDays": _vm.selectRestrictionWeekDays,
      "openMultiSelectModal": _vm.openMultiSelectModal,
      "updateMultiSelectModal": _vm.updateMultiSelectModal
    }
  }), _vm._v(" "), _c('v-export-bookings', {
    ref: "exportbookings",
    attrs: {
      "rentals": _vm.userAllRentals
    }
  }), _vm._v(" "), _c('v-import-bookings-from-file', {
    attrs: {
      "rentals": _vm.userAllRentals
    }
  }), _vm._v(" "), _c('v-manage-locks', {
    attrs: {
      "rental": _vm.booking.rental ? _vm.booking.rental : _vm.rental,
      "booking": _vm.booking
    }
  }), _vm._v(" "), _c('v-multi-select', {
    attrs: {
      "enableOpenModal": _vm.enableOpenModal,
      "rental": _vm.currentRental,
      "isUpdatedValue": _vm.isUpdatedValue
    },
    on: {
      "changeRestriction": _vm.changeRestriction,
      "closeMultiSelectModal": _vm.closeMultiSelectModal,
      "updateModal": _vm.updateModal
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && !_vm.rentals.length && !_vm.rentalsFilteredOnCalendarNoRentals.length),
      expression: "!loading && !rentals.length && !rentalsFilteredOnCalendarNoRentals.length"
    }],
    staticClass: "list-rental-empty"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "no-result"
  }, [_vm._v(_vm._s(_vm.$t("rentals.index.no_result")))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-flex",
      "gap": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-setup",
    staticStyle: {
      "width": "275px",
      "padding": "10px 30px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToImportPage($event)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("onboarding.setup")) + "\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-setup",
    staticStyle: {
      "color": "#fff",
      "width": "200px",
      "padding": "10px 30px"
    },
    attrs: {
      "target": "_blank",
      "href": "https://academy.superhote.com/login"
    }
  }, [_vm._v(_vm._s(_vm.$t("calendar.index.tutos")))])])])]), _vm._v(" "), _c('v-import-new-airbnb-rentals', {
    ref: "airbnbImportModal"
  }), _vm._v(" "), _c('v-sync-in-progress-modal'), _vm._v(" "), _c('v-sync-tmp-change-modal'), _vm._v(" "), _c('v-sync-tmp-change-modal-reservations')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f0da0a8"}!./src/app/pages/calendar/index/index.html
// module id = 1410
// module chunks = 0